import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getSession } from '../../utils/authUtils';
import logo from '../../assets/VisibeenLogo.png';

const HeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#0B91D6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '80px',
  padding: '0 30px'
}));

const HeaderLogo = styled('img')(({ theme }) => ({
  height: '40px',
  width: 'auto',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease',
  '&:hover': {
    opacity: 0.8
  }
}));

const UserInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}));

const UserName = styled(Typography)(({ theme }) => ({
  color: '#FFFFFF',
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 500
}));

const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: '40px',
  height: '40px',
  backgroundColor: '#FFFFFF',
  color: '#0B91D6'
}));

const Header = () => {
  const navigate = useNavigate();
  const session = getSession();
  const userName = session?.user?.name || 'User';
  const userInitial = userName.charAt(0).toUpperCase();

  return (
    <HeaderContainer>
      <HeaderLogo
        src={logo}
        alt="Visibeen"
        onClick={() => navigate('/dashboard')}
        title="Go to Dashboard"
      />
      <UserInfo>
        <UserName>{userName}</UserName>
        <UserAvatar>{userInitial}</UserAvatar>
      </UserInfo>
    </HeaderContainer>
  );
};

export default Header;